<!-- Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. -->

<!-- Material Look-n-Feel -->
<mat-extended-select
	class="grid-ticket-subcomponent-wrapper__input"
	[option$]="milestoneTypes$"
	[valuePath]="['value']"
	[labelPath]="['label']"
	automationId="milestoneTypeSelector"
	[placeholder]="appStrings.TICKET_MILESTONE_TYPE_PLACEHOLDER"
	[formControl]="internalField"
	[required]="false"
	[includeNotSetOption]="true"
	[isNotSetValid]="true"
>
</mat-extended-select>
